"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.webApp = exports.marketingSite = exports.api = exports.asset = exports.stripTrailingSlash = exports.stripLeadingSlash = void 0;
const config_1 = __importDefault(require("../config"));
const stripLeadingSlash = (input) => input.replace(/^\//, '');
exports.stripLeadingSlash = stripLeadingSlash;
const stripTrailingSlash = (input) => input.replace(/\/$/, '');
exports.stripTrailingSlash = stripTrailingSlash;
const asset = (path) => `${config_1.default.assetsBaseUrl}/${(0, exports.stripLeadingSlash)(path)}`;
exports.asset = asset;
const api = (path) => `${config_1.default.apiBaseUrl}/${(0, exports.stripLeadingSlash)(path)}`;
exports.api = api;
const marketingSite = (path) => `${config_1.default.marketingSiteBaseUrl}/${(0, exports.stripLeadingSlash)(path)}`;
exports.marketingSite = marketingSite;
const webApp = (path) => `${config_1.default.webAppBaseUrl}/${(0, exports.stripLeadingSlash)(path)}`;
exports.webApp = webApp;
